import { render } from "./Auctions.vue?vue&type=template&id=260c2563"
import script from "./Auctions.vue?vue&type=script&lang=js"
export * from "./Auctions.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__